import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Directive({
  selector: '[app-mask]',
})
export class MaskDirective {
  @Input('app-mask') mask;
  // @Output() ngModelChange = new EventEmitter<string>();

  @HostListener('keyup', ['$event'])
  onKeyup($event: any) {
    if ($event.keyCode === 8) {
      return;
    }

    let valor = $event.target.value.replace(/\D/g, '');
    const pad = this.mask.replace(/\D/g, '').replace(/9/g, '_');
    let valorMask = valor + pad.substring(0, pad.length - valor.length);

    let valorMaskPos = 0;
    valor = '';
    const selectionStart = $event.target.selectionStart;
    const valueLength = $event.target.value.length;
    // if (!isNaN(+$event.key) && valueLength === this.mask.length && $event.target.selectionStart < this.mask.length) {
    //   const preValue = $event.target.value.substring(0, selectionStart);
    //   const posValue = $event.key + $event.target.value.substring(selectionStart);
    //   valorMask = (preValue + posValue).replace(/\D/g, '');
    // }

    for (let i = 0; i < this.mask.length; i++) {
      if (isNaN(parseInt(this.mask.charAt(i), 10))) {
        valor += this.mask.charAt(i);
      } else {
        valor += valorMask[valorMaskPos++];
      }
    }

    if (valor.indexOf('_') > -1) {
      valor = valor.substr(0, valor.indexOf('_'));
    }

    $event.target.value = valor;
    // this.ngModelChange.emit($event.target.value);

    // if (!isNaN(+$event.key) && valueLength === this.mask.length) {
    //   $event.target.selectionStart = selectionStart + 1;
    //   $event.target.selectionEnd = selectionStart + 1;
    // }
  }

  // @HostListener('blur', ['$event'])
  // onFocusOut($event: any) {
  //   if ($event.target.value.length === this.mask.length) {
  //     return;
  //   }
  //   $event.target.value = '';
  //   this.ngModelChange.emit($event.target.value);
  // }

  // @HostListener('paste', ['$event'])
  // onPaste() {
  // }
}
